import React from "react";
import { FormatCurrencyWithoutSymbol } from "../../../../../Services/Utils";

export const getColumns = (tab) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;
        return <>{rowNumber}</>;
      },
    },
  },
  {
    name: "paymentDate",
    label: "Tanggal BBK",
    options: {
      sort: false,
    },
  },
  {
    name: "paymentRealizationDate",
    label: "Tanggal Realisasi BBK",
    options: {
      sort: false,
      display: tab === "REALISASI",
    },
  },
  {
    name: "paymentBankId",
    label: "Nomor BBK",
    options: {
      sort: false,
    },
  },
  {
    name: "documentType",
    label: "Jenis Dokumen",
    options: {
      sort: false,
    },
  },
  {
    name: "documentRef1",
    label: "No. Dokumen Ref 1",
    options: {
      sort: false,
    },
  },
  {
    name: "documentRef1Date",
    label: "Tanggal Dokumen Ref 1",
    options: {
      sort: false,
    },
  },
  {
    name: "bankId",
    label: "Kode Bank",
    options: {
      sort: false,
    },
  },
  {
    name: "bankName",
    label: "Nama Bank",
    options: {
      sort: false,
    },
  },
  {
    name: "nomorRekening",
    label: "Nomor Rekening",
    options: {
      sort: false,
    },
  },
  {
    name: "namaRekening",
    label: "Nama Rekening",
    options: {
      sort: false,
    },
  },
  {
    name: "transactionPersonName",
    label: "Bayar Kepada",
    options: {
      sort: false,
    },
  },
  {
    name: "paymentAmount",
    label: "Nilai Rupiah",
    options: {
      customBodyRender: (value, _) => {
        return <>{FormatCurrencyWithoutSymbol({ number: value })}</>;
      },
      sort: false,
    },
  },
  {
    name: "printCount",
    label: "Count Cetakan",
    options: {
      sort: false,
    },
  },
  {
    name: "printStatus",
    label: "Status Cetakan",
    options: {
      sort: false,
    },
  },
];

export const formGroup = {
  bankName: { value: null, mandatory: true },
  bankCode: { value: null },
  namaBayarKepada: { value: null, mandatory: true },
  nilaiRupiah: { value: 0, mandatory: true },
  accountName: { value: null, mandatory: true },
  accountNumber: { value: null, mandatory: true },
  jenisRelasi: { value: null, mandatory: true },
  terbilang: { value: "" },
  gunaMembayar: { value: "", mandatory: true },
  keterangan: { value: "", mandatory: true },
  jenisTransaksi: { value: null, mandatory: true },
  jenisDokumen: { value: null, mandatory: true },
  realisasi: { value: false },
  dataSpecialCategory: { value: null },
};
